function tickFormatter(value: number): string {
  // formatting axis tick line labels to the thousandth with a k appended, sans 0
  if (value > 1000) {
    const thousandth: number = value / 1000;
    return `${thousandth}${(value !== 0) ? "k" : ""}`;
  }

  return value.toString();
}

const colors = {
  blue: "rgba(159, 204, 253, 1)",
  cyan: "rgba(32, 197, 197, 0.7)",
  green: "rgba(185, 243, 183, 1)",
  lightBlue: "rgba(220, 236, 255, 1)",
};

const networkCompositionColors = {
  brightCyan: "33B9DF",
  cream: "D9C897",
  darkBlue: "00638C",
  lightYellow: "F3DA8A",
  marigold: "E3A112",
  water: "D9F2F9",
}

const hospitalAndPcpColors = {
  blue: "#7FCAFE",
  green: "#86E0A2",
  peach: "#FFAFA4",
  purple: "#C4A8FE",
  yellow: "#FFDA65",
}

const percentOfMarketColors = {
  lightBlue: "#D6EDFF",
  purple: "#8B95C9",
};

const widgetTooltipCursor = {
  cursor: "pointer",
  pointerEvents: "auto",
}

export {
  colors,
  networkCompositionColors,
  hospitalAndPcpColors,
  percentOfMarketColors,
  tickFormatter,
  widgetTooltipCursor,
};
